/**
 * Core module exports.
 * Re-exports all core functionality for easy importing.
 * Pure TypeScript - no React dependencies.
 */

// Core modules
export * from "./chartApiUtils";
export * from "./colorPalette";
export * from "./constants";
export * from "./debouncedOperations";
export * from "./debug";
export * from "./formatters";
export * from "./getChartConfig";
export * from "./getChartDates";
export * from "./hitTesting";
export * from "./hoverUtils";
export * from "./indicatorUtils";
export * from "./interactionUtils";
export * from "./intervalUtils";
export * from "./pathGenerators";
export * from "./priceSeriesUtils";
export * from "./scales";
export * from "./tickGeneration";
export * from "./viewport";

// ChartStore - only export createChartStore function (types come from types/)
export { createChartStore } from "./chartStore";

// DataUtils - all utility functions
export {
  appendPoints,
  applyAutoDownsampling,
  detectGaps,
  downsample,
  extractClosePrices,
  fillGaps,
  filterToRange,
  getCombinedDomain,
  getMedianInterval,
  getNormalizationBase,
  getPointValue,
  getOhlcvDomain,
  getTimeDomain,
  getValueDomain,
  getVolumeDomain,
  isSortedByTimestamp,
  mergePoints,
  normalizeSeries,
  normalizeToPercentageChange,
  ohlcvToPricePoints,
  resampleToCommonGrid,
  sortByTimestamp,
  trimToMaxPoints,
  trimToTimeRange,
  alignSeriesToPrimaryRange,
  validateOhlcvPoint,
  validatePricePoint,
  validateSeries,
} from "./dataUtils";

// Layout - utility functions and constants (types come from types/)
export {
  calculateHeightDistribution,
  calculateLayout,
  calculateTypography,
  chartToScreenCoords,
  DEFAULT_PADDING,
  DEFAULT_VOLUME_HEIGHT_RATIO,
  DEFAULT_X_AXIS_HEIGHT,
  DEFAULT_Y_AXIS_WIDTH,
  getAreaAtPoint,
  MIN_CHART_HEIGHT,
  MIN_CHART_WIDTH,
  MIN_PRICE_HEIGHT,
  MIN_VOLUME_HEIGHT,
  screenToChartCoords,
  validateLayout,
} from "./layout";
